import { adjustToNYTime } from '../../../../../global/helpers/date-helpers';
import { ActivedAndTerminatedPlan, PlanSummaryDto } from '../institution-model';

export enum PlanStatus {
	TerminatedInFuture,
	ActiveInFuture,
	Activated,
}

export interface CurrentPlan {
	plan: PlanSummaryDto,
	status: PlanStatus,
}

export function getCurrentPlan(plans: ActivedAndTerminatedPlan): CurrentPlan {
	const terminated = plans?.terminated[0];
	const active = plans?.active[0];
	const today = adjustToNYTime(new Date(Date.now()));
	if (terminated && (new Date(terminated?.latest_amendment_date).getTime() > today?.getTime())) {
		return {
			plan: terminated,
			status: PlanStatus.TerminatedInFuture,
		};
	}
	if (active && (new Date(active?.effective_date).getTime() > today?.getTime())) {
		return {
			plan: active,
			status: PlanStatus.ActiveInFuture,
		};
	}
	if (active) {
		return {
			plan: active,
			status: PlanStatus.Activated,
		};
	}
	return null;
}